const toRelativeHref = (href: string): string => {
  try {
    const url = new URL(href, window.location.origin);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return href;
  }
};

export const pushUrl = (href: string, state: Record<string, unknown> = {}): void => {
  const nextHref = toRelativeHref(href);
  const currentHref = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (nextHref === currentHref) {
    return;
  }

  window.history.pushState(state, '', nextHref);
};

export const readQueryParam = (href: string, key: string): string | null => {
  try {
    const url = new URL(href, window.location.origin);
    return url.searchParams.get(key);
  } catch (error) {
    return null;
  }
};

